export function updateTieredTonerValuesWithDefaults(newSheetData, unitData) {
  if (!newSheetData?.systemScheduleItems || !unitData) return;

  newSheetData.systemScheduleItems
    .filter((x) => x)
    .forEach((item) => {
      const unitId = item.unit?.value;
      if (!unitId) return;

      const matchedUnit = unitData.find((x) => x.id === unitId);
      if (!matchedUnit) return;

      item.tier1DefaultPercentage = matchedUnit.tier1DefaultPercentage;
      item.tier2DefaultPercentage = matchedUnit.tier2DefaultPercentage;
      item.tier2DefaultValue = matchedUnit.tier2DefaultValue;
      item.tier3DefaultValue = matchedUnit.tier3DefaultValue;
      item.vMinPercentageTier1 = matchedUnit.vMinPercentageTier1;
      item.vMaxPercentageTier1 = matchedUnit.vMaxPercentageTier1;
      item.vMaxPercentageTier2 = matchedUnit.vMaxPercentageTier2;
      item.vMinValueTier2 = matchedUnit.vMinValueTier2;
      item.vMaxPercentageTier3 = matchedUnit.vMaxPercentageTier3;
      item.vMinValueTier3 = matchedUnit.vMinValueTier3;

      if (!item.tier1UpperBoundaryPercentage?.isFixed) {
        item.tier1UpperBoundaryPercentage = {
          ...item.tier1UpperBoundaryPercentage,
          value: matchedUnit.tier1DefaultPercentage,
        };
      }
      if (!item.tier2UpperBoundaryPercentage?.isFixed) {
        item.tier2UpperBoundaryPercentage = {
          ...item.tier2UpperBoundaryPercentage,
          value: matchedUnit.tier2DefaultPercentage,
        };
      }
      if (!item.tier2Adds?.isFixed) {
        item.tier2Adds = {
          ...item.tier2Adds,
          value: matchedUnit.tier2DefaultValue,
        };
      }
      if (!item.tier3Adds?.isFixed) {
        item.tier3Adds = {
          ...item.tier3Adds,
          value: matchedUnit.tier3DefaultValue,
        };
      }
    });
}
